module.exports = __webpack_public_path__ + "img/icon-warning-snow-orange.025558e2.svg";